/**
 *功能: 路由配置项
 */

import login from '../../views/login';

export default [
	{
		path: '/login',
		name: 'login',
		component: login,
		meta: {
			title: '客户登录',
		},
	},
  {
    path: '/servicelogin',
    name: 'servicelogin',
    component: login,
    meta: {
      title: '客服登录',
    },
  },
];
